import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import TiaPatyHome from './components/Pages/TiaPatyHome';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<TiaPatyHome />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
